module.exports = __webpack_public_path__ + "static/media/banner_new_suppliers@2x.84bbbc88.png";